import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  getPreviousPricesFromId,
  getFiltersFromId,
  editFromId,
  editFiltersFromId,
  newItem
} from '../../API/AppointmentActions';
import {
  form,
  previousPricesForm,
  filtersForm
} from '../Form/appointmentActions';
import { form as searchForm } from '../Form/Search/appointmentActions';

import { appointmentActions as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "appointmentAction",
    pageTitle: strings.common.homepage.appointmentAction,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_APPOINTMENT_ACTION_CREATE'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.name) {
        result["name"] = search.name;
      }
      return result;
    },

    availableItemDisplay:['tab'],
    itemDisplay: {
      tab: {
        headers: [
          {
            label: strings.appointmentAction.index.tab.headers.name,
            value: "name"
          },
          {
            label: strings.appointmentAction.index.tab.headers.code,
            value: "code"
          },
          {
            label: strings.appointmentAction.index.tab.headers.quantityCredit,
            value: "quantity_credit"
          },
          {
            type: "price",
            label: strings.appointmentAction.index.tab.headers.price,
            value: "price"
          },
        ]
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.appointmentAction,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "name",
    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.appointmentAction.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_APPOINTMENT_ACTION'],
        editable: ['ROLE_APPOINTMENT_ACTION_CREATE']
      },
      previousPrices: {
        title: strings.appointmentAction.tab.previousPrices,
        type: 'form',
        form: previousPricesForm,

        onUpdateItem: (data) => {},

        apiGet: getPreviousPricesFromId,

        role: ['ROLE_APPOINTMENT_ACTION'],
        editable: false
      },
      filters: {
        title: strings.appointmentAction.tab.filters,
        type: 'form',
        form: filtersForm,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFiltersFromId,
        apiEdit: editFiltersFromId,

        role: ['ROLE_APPOINTMENT_ACTION'],
        editable: ['ROLE_APPOINTMENT_ACTION_CREATE']
      }
    }
  },
  new: {
    pageTitle: strings.appointmentAction.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (appointmentAction) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
